import React from "react";
import Markdown from "components/Markdown";
import { HeaderPicture, MarkdownContainer } from "./CardDescriptionStyled";
import { useTranslate } from "hooks/translation-hooks";
import { useCardDescription } from "./cardDescriptionHook";

export const CardDescription = ({
  type,
  description,
  moreInformation,
  removeMarkdownBorderRadius
}) => {
  const t = useTranslate();
  const { eventType } = useCardDescription({
    type,
    description,
    moreInformation
  });

  return (
    <>
      <HeaderPicture eventType={eventType} />
      <MarkdownContainer
        removeMarkdownBorderRadius={removeMarkdownBorderRadius}
      >
        <Markdown text={t(`${eventType.toLowerCase()}_card-markdown`)} />
      </MarkdownContainer>
    </>
  );
};

export default CardDescription;
